import React from "react"
import { styled, Theme } from "@mui/material/styles"
import Avatar from "components/atoms/Avatar"

type RandomPositionedAvatarsProps = {
  users: Record<string, any>[];
  avatarKey: string
}

export default function RandomPositionedAvatars(props: RandomPositionedAvatarsProps) {
  const { users, avatarKey } = props

  return (
    <Container
      sx={{
        width: users.length === 3 ? 42 : 42,
        height: users.length === 3 ? 52 : 42
      }}
    >
      {users.length === 1 && <Avatar imageSrc={users[0][avatarKey]}/>}
      {users.length === 2 && users.map((user, index) => (
        <TwoAvatarsWrapper key={index} index={index}>
          <Avatar imageSrc={user[avatarKey]}/>
        </TwoAvatarsWrapper>
      ))}
      {users.length === 3 && users.map((user, index) => (
        <ThreeAvatarsWrapper key={index} index={index}>
          <Avatar imageSrc={user[avatarKey]}/>
        </ThreeAvatarsWrapper>
      ))}
    </Container>
  )
}

const Container = styled("div")(({ theme }) => ({
  width: "42px",
  height: "52px",
  aspectRatio: 1,
  position: "relative",

  "& svg": {
    stroke: theme.palette.gray["9"],
    width: 16,
    height: 16
  }
}))

type AvatarsWrapperProps = {
  theme?: Theme;
  index: number;
}

const TwoAvatarsWrapper = styled("div")(({ theme, index }: AvatarsWrapperProps) => ({
  width: 32,
  height: 32,
  position: "absolute",
  borderRadius: "50%",
  border: "1px solid #FFFFFF",
  left: index % 2 === 0 ? 0 : "auto",
  right: index % 2 === 0 ? "auto" : 0,
  top: index === 0 ? 0 : "100%",
  transform: `translateY(${index === 0 ? "0" : "-100%"})`
}))

const ThreeAvatarsWrapper = styled("div")(({ theme, index }: AvatarsWrapperProps) => ({
  width: 32,
  height: 32,
  position: "absolute",
  borderRadius: "50%",
  border: "1px solid #FFFFFF",
  left: index % 2 === 0 ? 0 : "auto",
  right: index % 2 === 0 ? "auto" : 0,
  top: index === 0 ? 0 : (index === 1 ? "50%" : "100%"),
  transform: `translateY(${index === 1 ? "-50%" : (index === 0 ? "0" : "-100%")})`
}))
